import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useIdleTimeout } from '../hooks/useIdleTimeout';
import Sidebar from './Sidebar';
import Header from './Header';
import OperationsIndicator from './OperationsIndicator';
import './Layout.css';

export default function Layout() {
  const { logout } = useAuth();

  useIdleTimeout({
    onTimeout: () => {
      logout('session_timeout');
    },
  });

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-container">
        <Header />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
      <OperationsIndicator />
    </div>
  );
}
